import InstructorNavbar from "../components/instructor/InstructorNavbar";
import AddInstructorExperience from "../components/profile-forms/AddInstructorExperience";

const AddInstructorExperiencePage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <AddInstructorExperience/>
        </>
     );
}
 
export default AddInstructorExperiencePage;